import i18n from "@/plugins/vue-i18n";

export default function (value, isRequired) {
  return isRequired ? value : `${value} (${i18n.t("form.optional")})`;
}
